import { cx } from '@linaria/core';
import { useId, useRef, useEffect } from 'react';
import { loadEditorLibrary } from '@utils/common';
import { richtext } from './richtext.style.js';
import { jsx } from 'react/jsx-runtime';

function Richtext(props) {
  const internalId = useId();
  const id = props.id ?? internalId;
  const callbacksRef = useRef({
    onChange: props.onChange,
    onInitialized: props.onInitialized
  });
  callbacksRef.current = {
    onChange: props.onChange,
    onInitialized: props.onInitialized
  };
  useEffect(() => {
    if (props.readOnlyContent) {
      return;
    }
    let isActive = true;
    let editor;
    const initialize = async () => {
      const gEditor = window.gEditor ?? (await loadEditorLibrary());
      if (!isActive) {
        return;
      }
      if (!gEditor) {
        console.warn("<Richtext />: Unable to mount Richtext editor, window.gEditor() is not available.");
        return;
      }
      editor = await gEditor(`[id="${id}"`, {
        ...props,
        toolbarButtons: props.toolbarButtons ?? [],
        toolbarButtonsMD: props.toolbarButtonsMD ?? props.toolbarButtons ?? [],
        toolbarButtonsSM: props.toolbarButtonsSM ?? props.toolbarButtons ?? [],
        toolbarButtonsXS: props.toolbarButtonsXS ?? props.toolbarButtons ?? [],
        events: {
          ...props.events,
          blur(...args) {
            props.events?.blur?.call(this, ...args);
            const html = this.html.get();
            if (html) {
              callbacksRef.current.onChange?.(html);
            }
          },
          keyup(...args) {
            props.events?.keyup?.call(this, ...args);
            callbacksRef.current.onChange?.(this.html.get());
          },
          keypress(...args) {
            props.events?.keypress?.call(this, ...args);
            callbacksRef.current.onChange?.(this.html.get());
          },
          contentChanged(...args) {
            props.events?.contentChanged?.call(this, ...args);
            callbacksRef.current.onChange?.(this.html.get());
          }
        }
      });
      if (Array.isArray(editor)) {
        editor = editor[0];
      }
      if (props.initialValue) {
        editor?.html.set(props.initialValue ?? "");
      }
      if (editor) {
        callbacksRef.current.onInitialized?.(editor);
      }
    };
    initialize();
    return () => {
      isActive = false;
      editor?.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id, !!props.readOnlyContent]);
  if (props.readOnlyContent) {
    return /*#__PURE__*/jsx("div", {
      className: cx(props.className, richtext, "readOnly"),
      children: props.readOnlyContent
    }, "readonly");
  }
  return /*#__PURE__*/jsx("div", {
    id: id,
    className: cx(props.className, richtext)
  }, "input");
}

export { Richtext };
//# sourceMappingURL=richtext.js.map
